var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19335_31364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.875 3.14984C21.6171 2.98301 21.3222 2.88209 21.0162 2.85593C20.7102 2.82978 20.4024 2.8792 20.12 2.99984L10.865 6.64484C10.6459 6.73402 10.4116 6.77986 10.175 6.77984H4.25C3.75272 6.77984 3.27581 6.97739 2.92417 7.32902C2.57254 7.68065 2.375 8.15756 2.375 8.65484V8.80484H0.5V13.3048H2.375V13.4998C2.38675 13.9893 2.58947 14.4547 2.93983 14.7967C3.2902 15.1386 3.76042 15.33 4.25 15.3298L6.5 20.0998C6.65236 20.4211 6.89222 20.6928 7.19204 20.8838C7.49187 21.0749 7.83949 21.1775 8.195 21.1798H9.14C9.63468 21.1759 10.1077 20.9766 10.4561 20.6254C10.8045 20.2742 11 19.7995 11 19.3048V15.5098L20.12 19.1548C20.3443 19.2441 20.5836 19.2899 20.825 19.2898C21.1996 19.2838 21.5643 19.1692 21.875 18.9598C22.1217 18.7933 22.3252 18.5703 22.4687 18.3095C22.6121 18.0487 22.6914 17.7574 22.7 17.4598V4.69484C22.6986 4.38962 22.6228 4.08934 22.479 3.82009C22.3352 3.55084 22.1279 3.32077 21.875 3.14984ZM9.125 8.65484V13.4998H4.25V8.65484H9.125ZM9.125 19.3048H8.18L6.335 15.3298H9.125V19.3048ZM11.555 13.7248C11.3769 13.6338 11.1912 13.5585 11 13.4998V8.54984C11.1894 8.51077 11.375 8.45557 11.555 8.38484L20.825 4.69484V17.4148L11.555 13.7248ZM22.745 9.17984V12.9298C23.2423 12.9298 23.7192 12.7323 24.0708 12.3807C24.4225 12.029 24.62 11.5521 24.62 11.0548C24.62 10.5576 24.4225 10.0806 24.0708 9.72902C23.7192 9.37739 23.2423 9.17984 22.745 9.17984Z",
    fill: "#232F3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19335_31364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotion);
export default __webpack_public_path__ + "static/media/promotion.af8fedee6d048c06e79c91fa4630a5fc.svg";
export { ForwardRef as ReactComponent };